import {createSelector} from 'reselect';
import get from 'lodash/get';

const jobSelector = state => state.job;

export const getJobs = createSelector(
  [jobSelector],
  jobs => get(jobs, 'jobs', {})
);
